import { GetterTree } from 'vuex';
import { State } from './app.store';

const getters: GetterTree<State, State> = {
  sideNav(state: State): any {
    return state.currentSideNav;
  },
  getActiveCapabilities(state: State) {
    return state.activeCapabilities;
  },
  getIsForecastModalEnable(state: State) {
    return state.isForecastModalEnable;
  },
  getIsForecastEnable(state: State) {
    return state.isForcastEnabled;
  },
  getDisableDateTimePickerOptions(state: State) {
    return state.disableDateTimePickerOptions;
  },
  getCurrLang(state: State) {
    return state.currLang;
  },
  getPermissions(state: State) {
    return state.permissions;
  },
  getMiddlewareLoading(state: State) {
    return state.middlewareLoading;
  },
};

export default getters;
